<template>
  <div class="dashboard-editor-container">
    <div class="content">
        <div class="indexStatus" >
    </div>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import footerCom from '../components/footerCom.vue'
  import { methodPost } from '../../api/request.js'
  export default {
    name: 'dashboard-editor',
    components: {
      footerCom
    },
    computed: {
      ...mapGetters([
        'menu'
      ])
    },
    data() {
      return {
        currentTime: '', // 日期
        salesToday: '', // 今日销售额
        orderSendOutNum: '', // 待发货
        orderServiceNum: '', // 售后中
        withdrawalApplicationCount: '', // 提现申请
        orderNumsToday: '', // 新增订单
        todayNewManager: '', // 新增店长
        todayNewMembers: '', // 新增会员
        status: false
      }
    },
    activated() {
      if (this.menu[0].path !== '/dashboard') {
        this.status = false
      } else {
        this.status = true
        this.init()
      }
    },
    filters: {
      myCurrentTime: function(val) {
        return val.substring(0, 16)
      },
      formatNumber(value) {
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ',')
      }
    },
    methods: {
      goCompleteStatus() {
        this.$store.dispatch('ReportParams', {
          'configKey': '/config/%2Ftemplate%2Fmodule%2Forder%2Forder_management_list.json',
          'orderStatus': '3'
        })
        this.$router.push({ path: '/config/%2Ftemplate%2Fmodule%2Forder%2Forder_management_list.json' })
      },
      goaftersale() {
        this.$store.dispatch('ReportParams', {
          'configKey': '/config/%2Ftemplate%2Fmodule%2Forder%2Forder_aftersale_list.json',
          'completeStatus': '0'
        })
        this.$router.push({ path: '/config/%2Ftemplate%2Fmodule%2Forder%2Forder_aftersale_list.json' })
      },
      goCashWithdrawal() {
        this.$store.dispatch('ReportParams', {
          'configKey': '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fdistributor_cash_withdrawal.json',
          'auditStatus': '0'
        })
        this.$router.push({ path: '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fdistributor_cash_withdrawal.json' })
      },
      goUrl: function(url, data) {
        if (this.$router) {
          if (data) {
            this.$router.push({ path: url, query: data })
          } else {
            this.$router.push(url)
          }
        }
      },
      init() {
        methodPost('/customer/shoppingMallRule/findOperationHomePage')
          .then((res) => {
            if (res.code === 0) {
              const _data = res.data
              this.currentTime = _data.currentTime || '--'
              this.salesToday = _data.salesToday
              this.orderSendOutNum = _data.orderSendOutNum
              this.orderServiceNum = _data.orderServiceNum
              this.withdrawalApplicationCount = _data.withdrawalApplicationCount
              this.orderNumsToday = _data.orderNumsToday
              this.todayNewManager = _data.todayNewManager
              this.todayNewMembers = _data.todayNewMembers
            } else {
              this.$message.error(res.message)
            }
          }).catch(errData => {
          // this.$message.error('error 出错了')
          })
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-editor-container{
  overflow:auto;
  display:flex;
}
.grid-content {
  border-radius:8px;
  overflow: hidden;
}
.indexStatus{
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background:url("../../assets/image/dashboard-big.jpg") no-repeat center;
  background-size:100% 100%;
}
@media screen and (min-width: 1980px) {
  .indexStatus {
    background:url("../../assets/image/dashboard-small.jpg") no-repeat center;
  }
}
.content{
  position:relative;
  min-width:1000px;
  padding:20px 20px 0;
  flex:1;
  .hot-cont{
    width:100%;
    min-width:610px;
    height:233px;
    border-radius:4px 4px 0 0;
    background: linear-gradient(to right, #e1b573,#e7c383);
    .hot-cont-bg{
      position:relative;
      padding:0 45px 0 45px;
      color:#fff;
      display:flex;
      align-items:center;
      height:233px;
      //background:url("../../assets/image/index-hot-left.png") no-repeat left;
      background-size:399px 233px;
      z-index:0;
      .hot-bg-right{
        width:105px;
        position:absolute;
        top:0px;
        right:0px;
        height:233px;
       // background:url("../../assets/image/index-hot-right.png") no-repeat;
        background-size:105px 233px;
        z-index:1;
      }
    }
    .hot-top{
      z-index:2;
      flex:1;
      h2{
        font-size:36px;
        padding-bottom:10px;
        padding-left:10px;
        display: flex;
        align-items: flex-end;
        em{
          font-size:14px;
          position: relative;
          top: -5px;
        }
        .icon-tip{
          position:relative;
          top:-2px;
          cursor:pointer;
        }
      }
      p{
        font-size:16px;
        padding-bottom:10px;
        padding-left:10px;
      }
      span{
        display:inline-block;
        padding:5px 10px;
        border-radius:12px;
        color:#fdeee0;
        background:#d8a05d;
        font-size:12px;
      }
    }
    .hot-top-right{
        z-index:2;
        display:flex;
        flex:2;
        list-style: none;
        li{
          flex:1;
          color:#6a3f07;
          line-height:20px;
          text-align:center;
          span,b{
            display:block;
            font-size:12px;
            text-align:left;
          }
          b{
            font-size:22px;
          }
          a{
            display:inline-block;
          }
        }
        li:nth-child(2n){
          border-right:1px solid #bf9457;
          border-left:1px solid #bf9457;
          padding:0px;

        }
    }
  }
  .hot-list{
    padding:40px 30px 60px;
    background:#fff;
  }
  .hot-toady{
    display:flex;
    align-items: center;
    .title{
      color:#dbab6d;
      min-width:140px;
      font-size:14px;
      padding-right:30px;
      border-right:1px solid #f6f2ec;
      span{
        display:block;
        text-align:center;
      }
      .hot-icon{
        display:block;
        height:40px;
        background:url('../../assets/image/index-icon.png') no-repeat 50% top;
      }
      .hot-icon.vip{
        background-position:50% -108px;
      }
      .hot-icon.user{
        background-position:50% -210px;
      }

    }
    .toady-num{
      min-width:430px;
      flex:1;
      padding:10px 0 ;
      border-bottom:1px solid #f6f2ec;
      margin-left:30px;
      h2{
        position:relative;
        font-size:26px;
        padding-bottom:15px;
        min-height:44px;
        color:#39414c;
        padding-left:10px;
        .icon-tip{
          position:absolute;
          right:20px;
          top:0px;
          background-position:0 -285px;
        }
        .icon-tip.icon-tip-top{
          background-position:0 -264px;
        }
      }
      span{
        display:inline-block;
        padding:5px 10px;
        border-radius:10px;
        color:#39414c;
        background:#f7f7f7;
        font-size:12px;
      }
    }
  }
  .hot-link-w{
    border-radius:8px;
    width:335px;
    overflow:hidden;
  }
  .hot-link{
    position:relative;
    display:block;
    height:119px;
    font-size:18px;
    color:#fff;
    text-align:center;
    z-index:0;
    display:flex;
    align-items:center;
    cursor:pointer;
    p{
      position:absolute;
      top:45px;
      left:0;
      right:0;
      z-index:2;
      line-height:24px;
      span{
        display:block;
        font-size:12px;
        text-transform: uppercase;
      }
    }
    img{
      width:100%;
      height:100%;
       z-index:1;
    }
  }
}
@media screen and (max-width: 1440px) {
  .content{
     .hot-cont{
        .hot-top{
          flex:2;
        }
        .hot-top-right{
          flex:1;
          flex-direction:column;
          li{
            padding:0 0 20px;
            text-align: left;
          }
          li:nth-child(2n){
            border:0;
            padding:0 0 20px;
          }
          li:nth-child(3n){
            padding-bottom:0;
          }
        }
     }
  }
}

</style>
<style>
.el-tooltip__popper.is-light{
  border-color:#fff;
  box-shadow: 0 0 20px #dca864;
}
.el-tooltip__popper .popper__arrow {
  border-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/dashboard/index.vue